export enum Roles{
    Periodica = 'Periódico',
    Clinica = 'Clínico',
    Preventiva = 'Preventivo',
}

export const getDescricaoByCodigoAppointmentType = (codigo: string)=>{
    const values: string[] = Object.values(Roles)
    const keys: string[] = Object.keys(Roles)

    const index = keys.indexOf(codigo)
    return values[index]
}

export const getCodigoByDescricaoAppointmentType = (desc: string)=>{
    const values: string[] = Object.values(Roles)
    const keys: string[] = Object.keys(Roles)

    const index = values.indexOf(desc)
    return keys[index]
}